import { render } from "./ChannelCodeModify.vue?vue&type=template&id=701491aa&scoped=true"
import script from "./ChannelCodeModify.vue?vue&type=script&lang=js"
export * from "./ChannelCodeModify.vue?vue&type=script&lang=js"

import "./ChannelCodeModify.vue?vue&type=style&index=0&id=701491aa&lang=scss&scoped=true"
import "./ChannelCodeModify.vue?vue&type=style&index=1&id=701491aa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701491aa"]])

export default __exports__